import { Navigate, Route, Routes } from "react-router-dom";
import Admin from "../../components/admin/admin.component";
import Categories from "../../components/admin-categories/admin-categories.component";
import AdminCoupon from "../../components/admin-coupon/admin-coupon.component";
import QRCodeGenerator from "../../components/qr-generator/qr-generator.component";
import TransfersListPage from "./marketplace/TransfersListPage";
import TransferDetailPage from "./marketplace/TransferDetailPage";
import RewardWheelListPage from "./reward-wheel/RewardWheelListPage";
import RewardWheelCreatePage from "./reward-wheel/RewardWheelCreatePage";
import RewardWheelDetailPage from "./reward-wheel/RewardWheelDetailPage";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<Admin />} />
      <Route path="categories" element={<Categories />} />
      <Route path="coupons" element={<AdminCoupon />} />
      <Route path="qr-generator" element={<QRCodeGenerator />} />
      <Route path="marketplace/transfers" element={<TransfersListPage />} />
      <Route
        path="marketplace/transfers/:transferId"
        element={<TransferDetailPage />}
      />
      <Route path="reward/list" element={<RewardWheelListPage />} />
      <Route path="reward/list/create" element={<RewardWheelCreatePage />} />
      <Route path="reward/list/:wheelId" element={<RewardWheelDetailPage />} />
      <Route path="*" element={<Navigate to="/admin" />} />
    </Routes>
  );
};

export default AdminRoutes;
